import React, { useEffect, useRef, useState, useCallback } from "react";
import Genre from "../genre";
import ChannelListItem from "../channelListItem";
import { useHistory } from "react-router-dom";
import Notification from "../notification";
import localizationStrings from "../../statics/localization";
import BigLockIcon from "../../assets/icons/svg/BigLockIcon";
import { toggleLockById, toggleFavById } from "../../api/ltv/ltv";
import { now } from "moment/moment";


const ChannelListWidget = ({
  uKey,
  channels,
  genres,
  selectedChannel,
  onSelectChannel,
  setSelectedCutvProgram,
  selectedGenre,
  setSelectedGenre,
  isFilterOpen,
  setIsFilterOpen,
  adminProfile,
  profile,
  userFrameConfig,
  setLockChannelCode,
  setFavChannelCode,
  setCanWatch,
  isPlayer,
  showList,
  skipPinPrompt = false,
  trackIdPrefix
}) => {
  const [useFavoriteName, setUseFavoriteName] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [askAdminPin, setAskAdminPin] = useState(false);
  const [notificationText, setNotificationText] = useState(null);

  const history = useHistory();
  const itemRef = useRef(null);
  const isCanWatch = useRef(false);

  const onSelectGenre = (genre) => {
    setSelectedGenre(genre);
    setIsFilterOpen(!isFilterOpen);
    if (genre.columncode === "fav-channel") {
      setUseFavoriteName(true);
    } else {
      setUseFavoriteName(false);
    }
  };

  const checkLock = (item) => {
    isCanWatch.current = false; // Explicit lock toggles must not reuse a previous viewing-PIN intent.
    let textObject = {};
    itemRef.current = item;

    let isLocked = item?.interactions?.find(
      (element) => element === "CHANNEL_LOCK"
    );

    if (profile?.hasPin) {
      setShowPasswordModal(true);
      textObject.confirmText = localizationStrings.continue2;

      // if (profile?.main) {  //No need for admin profile seperation in new design
      //   if (!!isLocked) {
      //     textObject.text =
      //       localizationStrings.profile.enterAdminProfilePasswordToUnlock;
      //   } else {
      //     textObject.text =
      //       localizationStrings.profile.enterAdminProfilePasswordToLock;
      //   }
      // }
      //  else {
      if (!!isLocked) {
        textObject.text =
          localizationStrings.profile.enterProfilePasswordToUnlock;
      } else {
        textObject.text =
          localizationStrings.profile.enterProfilePasswordToLock;
      }
      // }  
    } else {
      textObject.text = localizationStrings.createProfilePinCodeText;
      textObject.confirmText = localizationStrings.createProfilePinCode;
    }

    setNotificationText(textObject);
    setShowNotification(true);
  };

  const clickConfirm = () => {
    console.log({ profile });
    setShowNotification(false);
    if (!showPasswordModal) {
      // This is the "Create PIN" case - clear any channel state and redirect
      itemRef.current = null;
      isCanWatch.current = false;
      history.push(`/profile/${profile?.id}`);
    }
  };

  const handleChannelLockAction = (channelId, validatedPin = null) => {
    // Only proceed with locking if this was a password modal (PIN entry)
    if (showPasswordModal) {
      handleToggleLock(channelId, validatedPin);
    }
    // If it's not a password modal, it means user was redirected to create PIN
    // and we shouldn't auto-lock anything
  };

  const handleToggleLock = async (channelId, validatedPin = null) => {
    // Use the validated PIN if provided, otherwise fall back to profile PIN
    const pinToUse = validatedPin || profile?.pin;
    const { data } = await toggleLockById(channelId, pinToUse);
    let isLocked = data.find((element) => element === "CHANNEL_LOCK");
    setLockChannelCode(channelId, isLocked);
  };

  const handleToggleFav = async (item) => {
    try {
      const { data } = await toggleFavById(item.id);
      // API returns updated interactions array
      let isFav = data.find((element) => element === "CHANNEL_FAV");
      // Call parent callback to update all states
      if (setFavChannelCode) {
        setFavChannelCode(item.id, isFav);
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
    }
  };

  const renderedGenreItems = genres?.map((genre) => {
    return (
      <Genre
        key={`${uKey}-${genre?.id}`}
        item={genre}
        selectedItem={selectedGenre}
        onSelect={onSelectGenre}
      />
    );
  });

  useEffect(() => {
    if (selectedChannel) {
      let isLocked = selectedChannel?.interactions?.find(
        (element) => element === "CHANNEL_LOCK"
      );

      let textObj = {};

      //eger prop gecilmişse sifre sorma, prop yoksa sor
      if (!!isLocked && selectedChannel.canWatch !== false && !selectedChannel.parentalUnlocked && !skipPinPrompt) {
        if (profile?.hasPin) {
          setShowPasswordModal(true);
          textObj.text = localizationStrings.profile.enterProfilePassword;
          textObj.confirmText = localizationStrings.enter;
        } else {
          textObj.text = localizationStrings.createProfilePinCodeText;
          textObj.confirmText = localizationStrings.createProfilePinCode;
        }

        isCanWatch.current = true;
        setNotificationText(textObj);
        setShowNotification(true);
        /* selectedChannel.canWatch = false; */

        /* isCanWatch.current = true; */
      }

      /*  if (selectedChannel.islocked === "1" && !selectedChannel?.canWatch) {
        let textObj = {};
        if (profile?.profileroleid === userFrameConfig.Kids_Profile_Id) {
          textObj.text = localizationStrings.profile.enterAdminProfilePassword;
          textObj.confirmText = localizationStrings.enter;
          setAskAdminPin(true);
        } else {
          if (profile.havepwd === "1") {
            setShowPasswordModal(true);
            textObj.text = localizationStrings.profile.enterProfilePassword;
            textObj.confirmText = localizationStrings.enter;
          } else {
            setShowPasswordModal(false);
            textObj.text = localizationStrings.createProfilePinCodeText;
            textObj.confirmText = localizationStrings.createProfilePinCode;
          }
        }

        isCanWatch.current = true;
        setNotificationText(textObj);

        setShowNotification(true);
      } */
    }
  }, [selectedChannel, skipPinPrompt]);

  const renderedChannelItems = channels?.map((item, index) => {
    return (
      <div key={`tys-${item.id}`} style={{ display: "flex" }}>
        <ChannelListItem
          key={`${uKey}-${item.id}`}
          item={item}
          index={index}
          selectedChannel={selectedChannel}
          onSelectChannel={onSelectChannel}
          useFavoriteName={useFavoriteName}
          onClickLock={(el) => checkLock(el)}
          onClickFav={(el) => handleToggleFav(el)}
          uKey={uKey}
          showList={showList}
          trackIdPrefix={trackIdPrefix}
        />
      </div>
    );
  });

  return (
    <div className="list" style={isPlayer ? { gap: "0" } : null}>
      <div
        id={`vertical-channel-list-${uKey}`}
        className="vertical-channel-list"
        style={
          isPlayer
            ? {
              maxHeight: "calc(100vh - 388px)",
              width: "100"
            }
            : null
        }
      >
        {renderedChannelItems}
      </div>
      <div
        className={`genre-container ${isFilterOpen ? (isPlayer ? "open-player" : "open") : ""
          }`}
      >
        <div
          className="vertical-genre-list"
          style={
            isPlayer
              ? {
                minHeight: "calc(100vh - 388px)",
                maxHeight: "calc(100vh - 388px)"
              }
              : null
          }
        >
          {renderedGenreItems}
        </div>
      </div>

      {showNotification ? (
        <Notification
          text={notificationText?.text}
          confirmText={notificationText?.confirmText}
          notConfirmText={localizationStrings.cancel}
          onClickConfirm={clickConfirm}
          onClickNotConfirm={() => {
            setShowNotification(false);
            isCanWatch.current = false;
          }}
          isPassword={showPasswordModal}
          // icon={<BigLockIcon />}
          theme="no-bg"
          logo={true}
          sendResult={(val, validatedPin) => {
            if (val) {
              if (isCanWatch.current) {
                setCanWatch(true);
              } else {
                handleChannelLockAction(itemRef.current?.id, validatedPin);
              }
              isCanWatch.current = false;
            }
          }}
          profileCode={profile?.id}
          dontUsePortal={isPlayer}
          // showCloseButton={true}
        />
      ) : null}
    </div>
  );
};

export default ChannelListWidget;
